import React from 'react';
import PropTypes from 'prop-types';
import Logo from 'fe-appdir-comp-logo';
import { MiniCard } from '../MiniCard';

const PROP_TYPES = {
  title: PropTypes.string.isRequired,
  logos: PropTypes.shape({
    oneX: PropTypes.string,
    twoX: PropTypes.string.isRequired,
  }).isRequired,
};

const MiniLogoCard = ({ logos, title, ...restProps }) => (
  <MiniCard
    {...restProps}
    title={title}
    graphic={() => (
      <Logo
        oneX={logos.oneX}
        twoX={logos.twoX}
        size={75}
        mobileSize={75}
        title={title}
      />
    )}
  />
);

MiniLogoCard.propTypes = PROP_TYPES;
MiniLogoCard.displayName = 'MiniLogoCard';

export { MiniLogoCard };
